import type { Validator } from './types';

export function makeMaxLengthValidator(maxLength: number, message: string): Validator<string> {
    return (value?: string) => (!value || value.length <= maxLength ? undefined : message);
}
